import $ from 'jquery';
import { Tab } from 'bootstrap';


$(function(){
    $('.burger-menu').on('click', function(){

      $('.website-header-wrapper').toggleClass('is-blue');

      $('.burger-menu div').toggleClass('white');
      $('.burger-menu2').toggleClass('hide');
      $('.burger-menu1, .burger-menu3').toggleClass('rotate');
    });
});

$(window).scroll(function() {
  if ($(window).scrollTop() > 50) {
    $('.website-header-wrapper').addClass('is-white');
  } else {
    $('.website-header-wrapper').removeClass('is-white');
  }
});

var header = document.querySelector('.website-header-wrapper');
var footer = document.querySelector('.site-footer');
var myTab = document.getElementById('myTab');

var featuresToggleSection = document.querySelector('.features-toggle-sections');

function getOffsetTop(element) {
    var offsetTop = 0;
    while(element) {
        offsetTop += element.offsetTop;
        element = element.offsetParent;
    }
    return offsetTop;
}

var headerHeight = header.offsetHeight;
var tabOffsetTop = getOffsetTop(myTab);

if(myTab) {
  window.addEventListener('scroll', function() {
    var scrollY = window.scrollY;

    // Check if we've scrolled past the tab's original position minus the header height
    if (scrollY > tabOffsetTop - headerHeight) {
        myTab.classList.add('sticky');
        featuresToggleSection.classList.add('sticky');
        
    } else {
        myTab.classList.remove('sticky');
        featuresToggleSection.classList.remove('sticky');
    }
});
}

// console.log($('button[data-bs-toggle="tab"]'));

// $('button[data-bs-toggle="tab"]').on('shown.bs.tab', function (e) {
//   // Scroll to the top of the content container
//   console.log('new tab');
//   $('.tab-content')[0].scrollIntoView({ behavior: 'smooth' });
// });

document.querySelectorAll('.top-nav-link').forEach(function(tab) {
  tab.addEventListener('shown.bs.tab', function(event) {
      document.querySelector('.features-toggle-sections').scrollIntoView({ behavior: 'smooth' });
  });
});

$(document).ready(function() {
  function getQueryParam(param) {
      let urlParams = new URLSearchParams(window.location.search);
      return urlParams.get(param);
  }

  function updateQueryStringParam(key, value) {
    let baseUrl = [location.protocol, '//', location.host, location.pathname].join('');
    let urlParams = new URLSearchParams(window.location.search);
    urlParams.set(key, value);
    history.replaceState(null, '', `${baseUrl}?${urlParams.toString()}`);
}

  let tab = getQueryParam('tab');

  if (tab) {
      let tabTrigger = new Tab(document.getElementById(tab));
      tabTrigger.show();
  }

    // Event delegation: Listen for clicks on the parent container

    let myTab = document.getElementById('myTab');

    if(!myTab) return;

    myTab.addEventListener('click', (event) => {
      // Check if the clicked element or its parent has the 'nav-link' class
      let targetElement = event.target;
      console.log(targetElement);
      while (targetElement && !targetElement.classList.contains('top-nav-link')) {
          targetElement = targetElement.parentElement;
      }

      if (targetElement && targetElement.classList.contains('top-nav-link')) {
          let activeTab = targetElement.id;
          updateQueryStringParam('tab', activeTab);
      }
  });

});